<template>
  <div
    class="my-4"v-if="list.length"
  >
    <div :id="carouselName" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          :class="{ active: index == 0 }"
          v-for="(item, index) in list"
          :key="index"
        >
        <a :href="item.link && item.link !== 'null' ? item.link : 'javascript:void(0)'">
          <img
            :src="'https://radgroups.ir/' + item.img"
            class="d-block w-100 rounded"
            :class="{'hero-21-9' : item.ratio == 1,'hero-16-9' : item.ratio == 2,'hero-16-6' : item.ratio == 3,'hero-4-1' : item.ratio == 4,'hero-3-1' : item.ratio == 5}"
          />
        </a>
        </div>
      </div>
      <div
        class="carousel-indicators mx-auto p-1 rounded"
        style="
          max-width: fit-content;
          background-color: rgba(114, 142, 167, 0.7);
        "
        v-if="list.length > 1"
      >
        <button
          v-for="(item, index) in list"
          :key="index"
          :class="{ active: index == 0 }"
          :data-bs-slide-to="index"
          :id="'ind' + item.id"
          :aria-label="'Slide ' + (index + 1)"
          type="button"
          :data-bs-target="'#' + carouselName"
          aria-current="false"
          class="my-btn1 mr-0 ra-mx-1"
        ></button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useCash } from "@/store/cash";
import { onMounted, nextTick, defineProps, ref, computed } from "vue";
import { Carousel } from "bootstrap";
const cashData = useCash();
const props = defineProps(["mode"]);
const carouselName = ref("carousel" + props.mode);
const list = ref([]);
onMounted(async () => {
  await cashData.getBanners();
  list.value = cashData.banners.filter((item) => item.zone_id == props.mode);
  nextTick(() => {
    const carouselElement = document.querySelector("#" + carouselName.value);
    if (carouselElement) {
      new Carousel(carouselElement, {
        interval: 6000,
        ride: "carousel",
      });
    }
  });
});
</script>

<style scoped>
.hero-21-9 {
  /* width: 100%; */
  height: 42.85vw;
  max-height: 450px;
} /* 21:9 */
.hero-16-9 {
  /* width: 100%; */
  height: 56.25vw;
  max-height: 500px;
} /* 16:9 */
.hero-16-6 {
  /* width: 100%; */
  height: 37.5vw;
  max-height: 300px;
} /* 16:6 */
.hero-4-1 {
  /* width: 100%; */
  height: 25vw;
  max-height: 350px;
} /* 4:1 */
.hero-3-1 {
  /* width: 100%; */
  height: 33.33vw;
  max-height: 400px;
} /* 3:1 */
* {
  touch-action: pan-y;
  user-select: auto;
}
.carousel-item {
  transition: transform 0.3s ease-in-out !important;
}

/* Global media queries for home-slider */
/* .home-slider {
  @media (min-width: 767px) {
    .image-slider {
      max-height: 300px !important;
      min-height: 300px !important;
    }
  }

  @media (min-width: 997px) {
    .image-slider {
      max-height: 500px !important;
      min-height: 500px !important;
    }
  }
}

*/
.my-btn1 {
  border-radius: 5px !important;
  width: 6px !important;
  height: 6px !important;
  background-color: rgb(238 241 249);
  margin-left: 0;
  border: none;
  opacity: 0.5;
  border: none !important;
}
.carousel-indicators .active {
  opacity: 1 !important;
}
@media (max-width: 997px) {
  .carousel-indicators {
    bottom: -5% !important;
  }
}
.carousel-indicators {
  bottom: -5%;
}
.ra-mx-1 {
  margin-right: 1px !important;
  margin-left: 1px !important;
}
</style>
